import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { feedPlayer } from "../../../globalStorage/autoplay";
import { getQueryParam } from "../../Utilities/QueryParam";
import { DesktopClip } from "./Components/DesktopDisplay";
import { MobileClip } from "./Components/MobileDisplay";
import { TClipVideoCardProps, TPaywallProps } from "./@types";
import { AllstarModalState } from "../../State/modals";
import { ModalType } from "../../@types";
import { analytics } from "MVVM/Analytics";

function isMobileSafari() {
  let isIos: any = navigator.userAgent.match(/iPod|iPhone|iPad/i);
  isIos = isIos ? true : false;
  return isIos;
}

export const ClipVideoCard = ({
  clip,
  to,
  autoplay,
  mutateReaction,
  followUnfollow,
  setClipInactive,
  isProfile,
  isMontage,
  isFeed,
  hideBigPlay,
  index,
  loading,
  createPrunedClip,
  isOwnProfile,
  hideDivider,
}: TClipVideoCardProps) => {
  const [, setSwappedForVideo] = useState(!isFeed);
  const [allstarModalState, setAllstarModalState] =
    useRecoilState(AllstarModalState);
  const [shareIdPlaying] = useRecoilState(feedPlayer);
  const mobileView = getQueryParam("mobileView");
  const isIos = isMobileSafari();
  const aModalIsOpen =
    allstarModalState.isOpen !== ModalType.None ||
    getQueryParam("youtube") ||
    getQueryParam("tiktok");
  autoplay = aModalIsOpen ? false : autoplay;

  useEffect(() => {
    analytics.page("Clip Card Impression", {
      path: window.location.pathname,
      shareId: clip.shareId,
      category: "clip impression",
    });
  }, [clip.shareId]);

  useEffect(() => {
    if (shareIdPlaying !== clip.shareId) {
      setSwappedForVideo(false);
    }
  }, [shareIdPlaying]); // eslint-disable-line

  const ALL_CLIP_PROPS = {
    isFeed: isFeed,
    autoplay: autoplay,
    to: to,
    followUnfollow: followUnfollow,
    clip: clip,
    hideBigPlay: hideBigPlay,
    mutateReaction: mutateReaction,
    isIos: isIos,
    isOwnProfile: isOwnProfile,
    createPrunedClip: () => {
      createPrunedClip({
        variables: {
          clipIdentifier: clip._id,
        },
      });
    },
    // all of these below should be recoil state within the components that actually open the modals. But since I have all these already being passd through im leaving it for now.
    setPaywallOpen: ({ open, type }: TPaywallProps) => {
      setAllstarModalState({
        data: { type: type, open: open },
        functions: {},
        isOpen: open ? ModalType.Paywall : ModalType.None,
      });
    },
    setRemixModalOpen: (isOpen: boolean) => {
      setAllstarModalState({
        data: clip,
        functions: {},
        isOpen: isOpen ? ModalType.Remix : ModalType.None,
      });
    },
    setDownloadModalOpen: (isOpen: boolean) => {
      setAllstarModalState({
        data: clip,
        functions: {},
        isOpen: isOpen ? ModalType.Download : ModalType.None,
      });
    },
    setShareModalOpen: (isOpen: boolean) => {
      setAllstarModalState({
        data: clip,
        functions: {},
        isOpen: isOpen ? ModalType.Share : ModalType.None,
      });
    },
    setReportModalOpen: (isOpen: boolean) => {
      setAllstarModalState({
        data: clip,
        functions: {},
        isOpen: isOpen ? ModalType.Report : ModalType.None,
      });
    },
    setModalOpen: (isOpen: boolean) => {
      setAllstarModalState({
        data: clip,
        functions: {},
        isOpen: isOpen ? ModalType.Feedback : ModalType.None,
      });
    },
    setEditModalOpen: (isOpen: boolean) => {
      setAllstarModalState({
        data: { ...clip, isMontage: isMontage },
        functions: { setClipInactive: setClipInactive },
        isOpen: isOpen ? ModalType.Delete : ModalType.None,
      });
    },
    setSignupModalOpen: (isOpen: boolean) => {
      setAllstarModalState({
        data: {},
        functions: {},
        isOpen: isOpen ? ModalType.Signup : ModalType.None,
      });
    },

    setFollowModal: ({ displayName, avatar }: any) => {
      setAllstarModalState({
        ...allstarModalState,
        isOpen: ModalType.Signup,
        data: {
          target: displayName,
          avatar: avatar,
          action: "follow",
        },
      });
    },
    isProfile,
    isMontage,
    loading,
    index,
    hideDivider,
  };

  return (
    <>
      {mobileView ? (
        <MobileClip {...ALL_CLIP_PROPS} />
      ) : (
        <DesktopClip {...ALL_CLIP_PROPS} />
      )}
    </>
  );
};
